export default __webpack_public_path__ + "static/media/selecao.8ce42fbe.webp";